import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results"]
  static values = {
    searchUrl: String,
    invitationUrl: String,
    csrfToken: String,
    candidates: Array
  }

  connect() {
    this.timeout = null
    this.renderHint("Start typing an alias and the list will narrow as you go.")
  }

  disconnect() {
    this.clear()
  }

  queue() {
    this.clear()
    const query = this.inputTarget.value.trim()

    if (query.length === 0) {
      this.renderHint("Start typing an alias and the list will narrow as you go.")
      return
    }

    this.timeout = setTimeout(() => this.search(query), 180)
  }

  async search(query) {
    try {
      let filtered = this.filterLocalCandidates(query)

      if (filtered.length === 0 && this.hasSearchUrlValue && this.searchUrlValue) {
        const response = await fetch(`${this.searchUrlValue}?q=${encodeURIComponent(query)}`, {
          headers: { Accept: "application/json" },
          credentials: "same-origin"
        })

        if (!response.ok) {
          throw new Error(`Search failed (${response.status})`)
        }

        filtered = await response.json()
      }

      if (filtered.length === 0) {
        this.renderHint("No matching aliases ready for invite.")
        return
      }

      this.resultsTarget.innerHTML = filtered.map((user) => this.rowFor(user, query)).join("")
    } catch (error) {
      console.error("channel invite search failed", error)
      this.renderHint("Invite lookup ran into an error.")
    }
  }

  filterLocalCandidates(query) {
    const normalized = String(query || "").trim().toLowerCase()
    if (!normalized.length) return []

    return (this.candidatesValue || [])
      .filter((user) => {
        const alias = String(user.alias || "").toLowerCase()
        const id = String(user.id || "")
        return alias.includes(normalized) || id === normalized
      })
      .slice(0, 24)
  }

  rowFor(user, query) {
    const alias = this.escapeHtml(user.alias || `USER #${user.id}`)
    const userId = Number(user.id)
    const inviteQuery = this.escapeHtml(query)
    const csrf = this.escapeHtml(this.csrfTokenValue)
    const invitationUrl = this.escapeHtml(this.invitationUrlValue)

    return `
      <div class="chewy-channel-invite-result">
        <a href="/users/${userId}" class="chewy-channel-invite-result-link">
          <span class="chewy-channel-member-name">${alias}</span>
          <span class="chewy-channel-member-role">user #${userId}</span>
        </a>
        <form action="${invitationUrl}" method="post" accept-charset="UTF-8">
          <input type="hidden" name="authenticity_token" value="${csrf}">
          <input type="hidden" name="invitee_id" value="${userId}">
          <input type="hidden" name="invite_query" value="${inviteQuery}">
          <button type="submit">mail invite</button>
        </form>
      </div>
    `
  }

  renderHint(text) {
    this.resultsTarget.innerHTML = `<p class="chewy-channel-invite-hint">${this.escapeHtml(text)}</p>`
  }

  escapeHtml(value) {
    return String(value)
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll("\"", "&quot;")
      .replaceAll("'", "&#39;")
  }

  clear() {
    if (this.timeout) {
      clearTimeout(this.timeout)
      this.timeout = null
    }
  }
}
